import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpLarge = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.3125 5.3125C9.6875 4.90625 10.3438 4.90625 10.7188 5.3125L16.7188 11.3125C17.125 11.6875 17.125 12.3438 16.7188 12.7188C16.3438 13.125 15.6875 13.125 15.3125 12.7188L10 7.4375L4.71875 12.7188C4.34375 13.125 3.6875 13.125 3.3125 12.7188C2.90625 12.3438 2.90625 11.6875 3.3125 11.3125L9.3125 5.3125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowUpLarge);
export default ForwardRef;
